"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Semaphore = void 0;
/**
 * Original credit to https://github.com/notenoughneon/await-semaphore
 * but added the ability to get more than 1 resource at a time
 */
class Semaphore {
    count;
    tasks = [];
    originalCount;
    constructor(count) {
        this.count = count;
        this.originalCount = count;
    }
    sched() {
        if (this.tasks.length > 0) {
            const n = this.tasks[0][1];
            if (this.count >= n) {
                let [next] = this.tasks.shift() ?? [];
                this.count = this.count - n;
                if (next === undefined) {
                    throw 'Unexpected undefined value in tasks list';
                }
                next();
            }
        }
    }
    acquire(n = 1) {
        if (n < 1) {
            throw new Error('n must be greater than or equal to 1');
        }
        else if (n > this.originalCount) {
            throw new Error(`n cannot be greater than the original total ${this.originalCount}`);
        }
        return new Promise((res, rej) => {
            const task = () => {
                let released = false;
                res(() => {
                    if (!released) {
                        released = true;
                        this.count = this.count + n;
                        this.sched();
                    }
                });
            };
            this.tasks.push([task, n]);
            if (process && process.nextTick) {
                process.nextTick(this.sched.bind(this));
            }
            else {
                setImmediate(this.sched.bind(this));
            }
        });
    }
    use(f) {
        return this.acquire()
            .then(release => {
            return f()
                .then((res) => {
                release();
                return res;
            })
                .catch((err) => {
                release();
                throw err;
            });
        });
    }
}
exports.Semaphore = Semaphore;
